import { __decorate } from "tslib";
import { Component, Prop, Mixins } from 'vue-property-decorator';
import FormMixin from '@/amui/mixins/formMixin';
let AmBizCheckSinglePosition = class AmBizCheckSinglePosition extends Mixins(FormMixin) {
  constructor() {
    super(...arguments);
    this.visible = false;
  }
  open() {
    this.visible = true;
  }
  cancel() {
    this.visible = false;
    this.checkedPositions = [];
    this.$emit('cancel');
  }
  confirm() {
    console.log(this.checkedPositions, '选择岗位数据');
    this.$emit('input', this.checkedPositions);
    this.$emit('confirm', this.checkedPositions);
    this.visible = false;
  }
};
AmBizCheckSinglePosition.componentName = 'AmBizCheckSinglePosition';
__decorate([Prop({
  default: 'button'
})], AmBizCheckSinglePosition.prototype, "selectType", void 0);
__decorate([Prop({
  default: '选择岗位'
})], AmBizCheckSinglePosition.prototype, "buttonText", void 0);
__decorate([Prop({
  default: 'primary'
})], AmBizCheckSinglePosition.prototype, "buttonType", void 0);
__decorate([Prop({
  type: Array,
  default: []
})], AmBizCheckSinglePosition.prototype, "checkedPositions", void 0);
__decorate([Prop({
  default: false
})], AmBizCheckSinglePosition.prototype, "multiple", void 0);
__decorate([Prop({
  default: false
})], AmBizCheckSinglePosition.prototype, "enableGroupCorp", void 0);
AmBizCheckSinglePosition = __decorate([Component({
  name: 'AmBizCheckSinglePosition'
})], AmBizCheckSinglePosition);
export default AmBizCheckSinglePosition;